<div class="board" [style]="style"
     (touchstart)="swipe($event, 'start')"
     (touchend)="swipe($event, 'end')"
>
  <div class="row" fxLayout="row" *ngFor="let row of board.bricks">
    <app-brick *ngFor="let brick of row" [brick]="brick" [size]="brickSize"></app-brick>
  </div>
  <app-plate [plate]="board.plate" [width]="width" [style]="plateStyle"></app-plate>
  <div class="ball" [style]="ballStyle"></div>
</div>
